angular.module('CarsSaraBo').factory('ContractService', ['$resource', function ($resource) {
    return $resource('../rest/company/:companyOid/contract/:oid',
        {
            companyOid: '@companyOid',
            oid: '@oid'
        },
        {
            update: {method: 'PUT'},
            getAll: {method: 'GET', isArray: true},
            migrate:{method: 'PUT'}
        }
    )
}
]);

angular.module('CarsSaraBo').factory('ContractPublishingService', ['$resource', function ($resource) {
    const publishingResource = $resource('../rest/company/:companyOid/contract/:oid/publishing',
        {companyOid: '@companyOid', oid: '@oid'}
    );

    function doPublishing(contractOid, companyOid, published) {
        var params = {companyOid: companyOid, oid: contractOid, published: published};
        return publishingResource.save(params, {}).$promise;
    }

    return {
        publishing: function (contractOid, companyOid, published) {
            return doPublishing(contractOid, companyOid, published);
        }
    }
}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/contract/contract_service.js
// module id = 920
// module chunks = 3